export default __webpack_public_path__ + "static/media/rating_5.981d28b1.png";